import { render } from "./EditEmailSubscription.vue?vue&type=template&id=44c9c8ba"
import script from "./EditEmailSubscription.vue?vue&type=script&lang=js"
export * from "./EditEmailSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__